// Video Swatches for Product Variants
// Auto-plays videos when variant swatches are selected

(function() {
  'use strict';

  // Configuration
  var config = {
    videoSelector: '[data-variant-video]',
    swatchSelector: '[data-swatch-item]',
    mediaWrapperSelector: '[data-product-single-media-group]',
    autoplay: true,
    muted: true,
    loop: true
  };

  // Video swatch manager
  var VideoSwatchManager = {
    currentVideo: null,
    variantVideos: new Map(),

    init: function() {
      this.bindEvents();
      this.parseVariantVideos();
    },

    bindEvents: function() {
      var self = this;

      // Listen for swatch selection
      document.addEventListener('click', function(e) {
        var swatch = e.target.closest(config.swatchSelector);
        if (swatch && swatch.hasAttribute('data-variant-id')) {
          var variantId = swatch.getAttribute('data-variant-id');
          self.playVariantVideo(variantId);
        }
      });

      // Listen for variant changes from theme's swatch system
      document.addEventListener('variant:changed', function(e) {
        if (e.detail && e.detail.variant && e.detail.variant.id) {
          self.playVariantVideo(e.detail.variant.id);
        }
      });

      // Handle theme's custom variant change events
      if (window.T4SThemeSP) {
        // Hook into theme's variant update system
        var originalUpdateVariant = window.T4SThemeSP.ProductItem && window.T4SThemeSP.ProductItem.updateVariant;
        if (originalUpdateVariant) {
          window.T4SThemeSP.ProductItem.updateVariant = function() {
            var result = originalUpdateVariant.apply(this, arguments);
            if (arguments[0] && arguments[0].id) {
              self.playVariantVideo(arguments[0].id);
            }
            return result;
          };
        }
      }
    },

    parseVariantVideos: function() {
      var self = this;

      // Look for variant video data in JSON scripts
      var videoDataScripts = document.querySelectorAll('.variant-video-data');

      videoDataScripts.forEach(function(script) {
        try {
          var videoData = JSON.parse(script.textContent);

          // Find the closest container with variant ID
          var container = script.closest('[data-id], [data-pfd-variant-id]');
          var variantId = container?.getAttribute('data-id') ||
                         container?.getAttribute('data-pfd-variant-id');

          if (variantId && videoData) {
            self.variantVideos.set(variantId, {
              data: videoData,
              element: null // Will be created when needed
            });
          }
        } catch (e) {
          console.error('Error parsing variant video data:', e);
        }
      });
    },

    playVariantVideo: function(variantId) {
      var self = this;

      // Stop current video if playing
      if (self.currentVideo && self.currentVideo !== self.variantVideos.get(variantId)) {
        self.stopVideo(self.currentVideo);
      }

      // Find and play the variant video
      var variantVideoData = self.variantVideos.get(variantId.toString());
      if (variantVideoData) {
        // Create video element if it doesn't exist
        var videoEl;
        if (variantVideoData.element) {
          videoEl = variantVideoData.element;
        } else {
          videoEl = VariantVideoLoader.createVideoElement(variantId, variantVideoData.data);
          variantVideoData.element = videoEl;
        }

        if (videoEl) {
          // Ensure video is visible
          self.showVideoContainer(videoEl);

          // Play the video
          self.playVideo(videoEl);
          self.currentVideo = videoEl;
        }
      } else {
        // If no video for this variant, hide any playing video
        if (self.currentVideo) {
          self.stopVideo(self.currentVideo);
          self.hideVideoContainer(self.currentVideo);
          self.currentVideo = null;
        }
      }
    },

    playVideo: function(videoEl) {
      if (videoEl.tagName === 'VIDEO') {
        videoEl.muted = true;
        videoEl.loop = config.loop;
        videoEl.playsInline = true;
        videoEl.autoplay = true;
        videoEl.setAttribute("muted", "");
        videoEl.setAttribute("playsinline", "");
        videoEl.preload = "auto";

        function tryPlay() {
          var p = videoEl.play();
          if (p && typeof p.catch === "function") {
            p.catch(function () {});
          }
        }

        if (videoEl.readyState >= 2) {
          tryPlay();
        } else {
          videoEl.load();
          videoEl.addEventListener("canplay", function () { tryPlay(); }, { once: true });
          videoEl.addEventListener("loadeddata", function () { tryPlay(); }, { once: true });
          setTimeout(tryPlay, 300);
          setTimeout(tryPlay, 1000);
        }
      } else if (videoEl.tagName === 'IFRAME') {
        videoEl.style.opacity = '1';
      }
    },

    stopVideo: function(videoEl) {
      if (videoEl.tagName === 'VIDEO') {
        videoEl.pause();
        videoEl.currentTime = 0;
      } else if (videoEl.tagName === 'IFRAME') {
        // For embedded videos, hide or reset
        videoEl.style.opacity = '0';
      }
    },

    showVideoContainer: function(videoEl) {
      var container = videoEl.closest(config.mediaWrapperSelector) ||
                     videoEl.closest('.t4s-product__media-item');
      // Skip .pfd-img-listing — that is PFD's data container, not a display target.
      // PFD manages its own gallery; hiding siblings there breaks variant image data.
      if (container) {
        container.style.display = 'block';
      }
    },

    hideVideoContainer: function(videoEl) {
      var container = videoEl.closest(config.mediaWrapperSelector) ||
                     videoEl.closest('.t4s-product__media-item');
      if (container) {
        container.style.display = 'none';
      }
    }
  };

  // Variant video loader - loads videos from metafields
  var VariantVideoLoader = {
    loadedVideos: new Set(),

    init: function() {
      // Videos are now loaded on-demand when variants are selected
      // The data is already parsed by VideoSwatchManager.parseVariantVideos()
    },

    createVideoElement: function(variantId, videoData) {
      // Find the media container - check for both regular and dynamic forms
      var mediaContainer = document.querySelector('.t4s-product__media') ||
                          document.querySelector('.pfd-main-imgs');

      if (!mediaContainer || !videoData) return;

      // Check if video already exists
      var existingVideo = mediaContainer.querySelector('.t4s-product__media-item--video[data-variant-id="' + variantId + '"]');
      if (existingVideo) return existingVideo;

      // Create video wrapper
      var videoWrapper = document.createElement('div');
      videoWrapper.className = 't4s-product__media-item t4s-product__media-item--video';
      videoWrapper.setAttribute('data-variant-video', '');
      videoWrapper.setAttribute('data-variant-id', variantId);
      videoWrapper.style.display = 'none';

      // Create video element
      var videoEl = document.createElement('video');
      videoEl.className = 't4s-product__media-video';
      videoEl.muted = config.muted;
      videoEl.loop = config.loop;
      videoEl.playsInline = true;
      videoEl.preload = 'metadata';

      // Normalize Shopify video object shapes.
      var sourceUrl = null;
      var sourceType = 'video/mp4';
      if (videoData.sources && Array.isArray(videoData.sources) && videoData.sources.length) {
        var preferredSource = videoData.sources.find(function(s) {
          return s && (s.mime_type === 'video/mp4' || s.format === 'mp4');
        }) || videoData.sources[0];
        if (preferredSource) {
          sourceUrl = preferredSource.url || null;
          sourceType = preferredSource.mime_type || sourceType;
        }
      } else if (videoData.url) {
        sourceUrl = videoData.url;
        sourceType = videoData.mime_type || videoData.type || sourceType;
      }

      if (!sourceUrl) return;

      // Add source
      var sourceEl = document.createElement('source');
      sourceEl.src = sourceUrl;
      sourceEl.type = sourceType;
      videoEl.appendChild(sourceEl);

      var poster =
        (videoData.preview_image && videoData.preview_image.src) ||
        (videoData.poster && videoData.poster.src) ||
        videoData.poster ||
        null;
      if (poster) {
        videoEl.poster = poster;
      }

      // Add video element to wrapper
      videoWrapper.appendChild(videoEl);

      // Add wrapper to media container
      mediaContainer.appendChild(videoWrapper);

      return videoEl;
    }
  };

  // Initialize when DOM is ready
  function init() {
    // Initialize video swatch manager
    VideoSwatchManager.init();

    // Make managers globally available
    window.VideoSwatchManager = VideoSwatchManager;
    window.VariantVideoLoader = VariantVideoLoader;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();